import React from "react";
import GenerateInput from "../GenerateInput";

export interface ChatPanelProps {}

export const ChatPanel = React.memo(({}: ChatPanelProps) => {
  return (
    <div className="w-full">
      <div className="mx-auto sm:max-w-2xl">
        {/* keep padding-top at 0 for usage indicator */}
        <div className="bg-background p-2 pb-1 pt-0">
          <div className="border-0 bg-background shadow-lg sm:rounded-t-xl">
            <GenerateInput isForChat={true} />
          </div>
        </div>
      </div>
    </div>
  );
});
